import { Alert, Button, Space } from 'antd';
import useNoCostForm from './useNoCostForm.hook';

export default function NoCostForm({
  subscriptionTypeId,
  amount,
  subscriptionParams,
  promotionCode,
}) {
  const { state, actions } = useNoCostForm({
    subscriptionTypeId,
    amount,
    subscriptionParams,
    promotionCode,
  });
  return (
    <Space direction="vertical" className="mt">
      <Space direction="vertical">
        <h3>This operation has no cost for you</h3>
        <p>Just confirm you want to continue</p>
        <Button
          type="primary"
          loading={state.processing}
          size="large"
          onClick={actions.confirm}
        >
          Confirm
        </Button>
      </Space>
      {state.error ? (
        <Alert
          message={state.error}
          type="error"
          closable
          onClose={actions.closeError}
        />
      ) : null}
    </Space>
  );
}
